import { useTranslation } from 'react-i18next'
import { Checkbox, Input } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { IQuestionBankQuestion } from 'interfaces/questionBank'
import { Wrapper } from './styled'

interface IProps {
  question: IQuestionBankQuestion
  setQuestion: (value: IQuestionBankQuestion) => void
}

const AnswerExplanation = ({ question, setQuestion }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix =
    'administration.blocks.type.questionBankV2.sections.manageQuestion.answerExplanation'

  const handleShowAnswerExplanation = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      setQuestion({ ...question, showAnswerExplanation: e.target.checked })
    } else {
      setQuestion({
        ...question,
        showAnswerExplanation: e.target.checked,
        answerExplanation: '',
      })
    }
  }

  return (
    <Wrapper>
      {question.showAnswerExplanation && (
        <>
          <div>
            {t(`${translationPrefix}.title`)}
            <FontAwesomeIcon icon={faInfoCircle} />
          </div>
          <Input.TextArea
            value={question.answerExplanation}
            onChange={(e) =>
              setQuestion({ ...question, answerExplanation: e.target.value })
            }
            autoSize={{ minRows: 4, maxRows: 4 }}
            autoFocus
          />
        </>
      )}
      <Checkbox
        checked={question.showAnswerExplanation}
        onChange={(e) => handleShowAnswerExplanation(e)}
      >
        {t(`${translationPrefix}.show`)}
      </Checkbox>
    </Wrapper>
  )
}

export default AnswerExplanation
